import React, { createContext, useContext, useState, ReactNode } from 'react';

interface RolloData {
  id_rollo: number | null;
  rollo_identificacion: string | null;
}

interface TicketData {
  id_balanza: number;
  numero_ticket: number;
  fecha: string;
  cliente: string;
  productor: string;
  kilos: number;
  rollos: RolloData[];
}

interface ProduccionData {
  tickets: TicketData[];
  productoId: string;
  productoNivel: string;
  arrayDatosCompletos: Array<{
    id_balanza: number;
    numero_ticket: number;
    fecha: string;
    cliente: string;
    cliente_id: number;
    productor: string;
    productor_id: number;
    producto: string;
    kilos: number;
    compra_servicio: string;
    id_rollo: number | null;
    rollo_identificacion: string | null;
    presentacion_id: number | null;
  }>;
}

interface ProduccionContextType {
  produccionData: ProduccionData | null;
  setProduccionData: (data: ProduccionData | null) => void;
  clearProduccionData: () => void;
}

const ProduccionContext = createContext<ProduccionContextType | undefined>(undefined);

export const useProduccionContext = () => {
  const context = useContext(ProduccionContext);
  if (context === undefined) {
    throw new Error('useProduccionContext must be used within a ProduccionProvider');
  }
  return context;
};

interface ProduccionProviderProps {
  children: ReactNode;
}

export const ProduccionProvider: React.FC<ProduccionProviderProps> = ({ children }) => {
  const [produccionData, setProduccionData] = useState<ProduccionData | null>(null);

  const clearProduccionData = () => {
    console.log('Limpiando datos del contexto de producción');
    setProduccionData(null);
  };

  const setProduccionDataWithLog = (data: ProduccionData | null) => {
    console.log('Guardando datos en contexto de producción:', data);
    setProduccionData(data);
  };

  return (
    <ProduccionContext.Provider value={{ produccionData, setProduccionData: setProduccionDataWithLog, clearProduccionData }}>
      {children}
    </ProduccionContext.Provider>
  );
};
